import { render, staticRenderFns } from "./VLoadingRow.vue?vue&type=template&id=28eb4102&scoped=true"
import script from "./VLoadingRow.vue?vue&type=script&lang=js"
export * from "./VLoadingRow.vue?vue&type=script&lang=js"
import style0 from "./VLoadingRow.vue?vue&type=style&index=0&id=28eb4102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb4102",
  null
  
)

export default component.exports